export default __webpack_public_path__ + "static/media/gallery10.3f72596b.jpg";